"use client";

import { createSystem, defaultConfig } from "@chakra-ui/react";
import { SYSTEM_COMMON } from "./common";

export const SYSTEM_ACOUNT_NATTI = createSystem(defaultConfig, SYSTEM_COMMON, {
  theme: {
    tokens: {
      colors: {
        primary: {
          50: { value: "#F5F8F8" },
          100: { value: "#D9E1E5" },
          200: { value: "#B9C8CF" },
          300: { value: "#92AAB4" },
          400: { value: "#7C99A5" },
          500: { value: "#608291" },
          600: { value: "#476F80" },
          700: { value: "#375968" },
          800: { value: "#2E4B58" },
          900: { value: "#21363F" },
        },
        secondary: {
          50: { value: "#F8F8EE" },
          100: { value: "#E1E3BD" },
          200: { value: "#C7CA83" },
          300: { value: "#A7AC3C" },
          400: { value: "#959A1D" },
          500: { value: "#7E8219" },
          600: { value: "#6A6E15" },
          700: { value: "#555811" },
          800: { value: "#484A0E" },
          900: { value: "#34360A" },
        },
      },
    },
  },
});
